import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'join'
})
export class JoinPipe implements PipeTransform {

  transform(separator: string, ...args: any[]): unknown {


    var filtered = [];
    if (!args) return '';

    if (!separator) separator = ', ';
    for(var i = 0; i < args.length; i++) {
      if (args[i]) {
        filtered.push(args[i]);
      }
    }
    return filtered.join(separator);

  }

}
